import { graphql } from "gql.tada";
import { RichTextFragment } from "./fragments/RichTextFragment";
import { MetadataFragment } from "./fragments/MetadataFragment";
import { LinkFragment } from "./fragments/LinkFragment";

export const GetArticlePageBySlug = graphql(
  /* GraphQL */ `
    query GetArticlePageBySlug(
      $locale: String
      $preview: Boolean
      $slug: String
    ) {
      articlePageCollection(
        locale: $locale
        preview: $preview
        where: { slug: $slug }
        limit: 1
      ) {
        items {
          __typename
          title
          modalTitle
          isVideoModal
          heroImage {
            contentType
            url
          }
          subtitle
          slug
          metadata {
            ...MetadataFragment
          }
          richText {
            ...RichTextFragment
          }
          nextUpLabel
          nextArticle {
            ...LinkFragment
          }
        }
      }
    }
  `,
  [RichTextFragment, MetadataFragment, LinkFragment]
);
